<div class="shadow-page-header loading-blocks">
  <div class="shadow-breadcrumbs"><fa-icon icon="angle-right"></fa-icon></div>
  <div class="shadow-page-title"></div>
</div>
<br><br><br>
<mat-spinner class="spinner-centre" *ngIf="showSpinner"></mat-spinner>
